import React from "react";
import { useNavigate } from "react-router-dom";

const AccessDenied = ({ title = "Acceso restringido", message = "No tienes permiso para realizar esta accion." }) => {
  const navigate = useNavigate();

  return (
    <div style={{
      maxWidth: 720,
      margin: "2rem auto",
      padding: "1.25rem",
      background: "#ffffff",
      border: "1px solid #e5e7eb",
      borderRadius: 14,
      boxShadow: "0 8px 24px rgba(15, 23, 42, 0.06)",
      fontFamily: "'Segoe UI', sans-serif",
    }}>
      <p style={{
        margin: "0 0 .35rem",
        color: "#64748b",
        fontSize: ".78rem",
        fontWeight: 800,
        textTransform: "uppercase",
        letterSpacing: ".06em",
      }}>
        Permisos
      </p>
      <h2 style={{ margin: 0, color: "#111827" }}>{title}</h2>
      <p style={{ color: "#475569" }}>{message}</p>
      <button
        type="button"
        onClick={() => navigate(-1)}
        style={{
          minHeight: 40,
          padding: ".6rem .95rem",
          border: "none",
          borderRadius: 10,
          background: "#2563eb",
          color: "#ffffff",
          cursor: "pointer",
          fontWeight: 800,
        }}
      >
        Volver
      </button>
    </div>
  );
};

export default AccessDenied;
